import http from './api'

const route = 'app/comercial/time/'

export default {
  showEvolucaoTimeSupervisor: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showEvolucaoTimeSupervisor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },

  showEvolucaoTimeVendedores: (item, dataInicio, dataFim, select, tokenContrato) => {
    return http.post(route + 'showEvolucaoTimeVendedores', {
      item: item,
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      tokenContrato: tokenContrato,
    })
  },

  showAtigimentoMetaPeriodo: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedor) => {
    return http.post(route + 'showAtigimentoMetaPeriodo', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedor,
    })
  },

  showTicketMedioSupervisor: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedor) => {
    return http.post(route + 'showTicketMedioSupervisor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedor,
    })
  },

  showTicketSupervisorxEmpresa: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedor) => {
    return http.post(route + 'showTicketSupervisorxEmpresa', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedor,
    })
  },

  showLocalizacaoSupervisores: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedor) => {
    return http.post(route + 'showLocalizacaoSupervisores', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedor,
    })
  },

  showCoberturaVendedor: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showCoberturaVendedor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },

  showDetalheCoberturaVendedor: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showDetalheCoberturaVendedor', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },

  showEvolucaoTimeVendas: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, vendedor) => {
    return http.post(route + 'showEvolucaoTimeVendas', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      vendedor: vendedor,
    })
  },

  showEvolucaoTimeVendasVolume: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, segmento, rede, categoria, promotor, classificacao, vendedor) => {
    return http.post(route + 'showEvolucaoTimeVendasVolume', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      vendedor: vendedor,
    })
  },

  showComparativoFaturamentoMesesAnteriores: (select, supervisor, vendedores, areas, redes, receita, tokenContrato, segmento, vendedoresSelect) => {
    return http.post(route + 'showComparativoFaturamentoMesesAnteriores', {
      select: select,
      supervisor: supervisor,
      vendedor: vendedores,
      area: areas,
      rede: redes,
      receita: receita,
      tokenContrato: tokenContrato,
      segmento: segmento,
      vendedorSelect: vendedoresSelect,
    })
  },
}
